import React from "react";
import { Row, Col, Checkbox, InputNumber } from "antd";
import "../styles.css";

const spanstyles = {
  marginRight: 8,
};

export const getDestructiveExpirationSettingsDefaultConfigs = {
  destructive_expiration_set_retention: false,
  destructive_expiration_year: undefined,
  destructive_expiration_month: undefined,
  destructive_expiration_days: undefined,
  destructive_expiration_edit_retention: false,
};

function DestructiveExpirationSettings(props) {
  return (
    <div className="app_config_checkbox_class2">
      <Row>
        <Col xxl={2} xl={3} lg={4} sm={6}>
          <span style={spanstyles}>
            <Checkbox
              onChange={(e) =>
                props.updateValue(
                  e.target.checked,
                  props._id,
                  "destructive_expiration_set_retention"
                )
              }
              checked={props.config.destructive_expiration_set_retention}
            />
          </span>
          <span style={spanstyles}>Set Retention</span>
        </Col>
        <Col xxl={4} xl={6} lg={8} sm={12} style={{ minWidth: 320 }}>
          <span style={spanstyles}>
            <InputNumber
              width={100}
              onChange={(e) =>
                props.updateValue(e, props._id, "destructive_expiration_year")
              }
              value={props.config.destructive_expiration_year}
              placeholder="Year"
            />
          </span>
          <span style={spanstyles}>
            <InputNumber
              width={100}
              onChange={(e) =>
                props.updateValue(e, props._id, "destructive_expiration_month")
              }
              value={props.config.destructive_expiration_month}
              placeholder="Month"
            />
          </span>
          <span style={spanstyles}>
            <InputNumber
              width={100}
              onChange={(e) =>
                props.updateValue(e, props._id, "destructive_expiration_days")
              }
              value={props.config.destructive_expiration_days}
              placeholder="Days"
            />
          </span>
        </Col>
        <Col xxl={2} xl={3} lg={4} sm={6}>
          <span style={spanstyles}>
            <Checkbox
              onChange={(e) =>
                props.updateValue(
                  e.target.checked,
                  props._id,
                  "destructive_expiration_edit_retention"
                )
              }
              checked={props.config.destructive_expiration_edit_retention}
            />
          </span>
          <span style={spanstyles}>Edit Retention</span>
        </Col>
      </Row>
    </div>
  );
}

export default React.memo(DestructiveExpirationSettings);
